import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../../System/Components/Loader'
import dayjs from 'dayjs'
import AddressTable from './Components/AddressTable';
import { Button, Col, DatePicker, Row, Tag } from 'antd';
import { useGlobal } from '../../System/Global/GlobalProvider';
import { unescapeNested } from '../../System/Global/unescapeArray';
import { getRecords } from '../../System/Api/OPEXAPI';

export const Bookings = () => {

    const { UserData } = useGlobal();
    const [ records, setRecords ] = useState([]);
    const [ dates, setDates ] = useState([dayjs().startOf('month'), dayjs().endOf('month')])
    const { status } = useParams();
    const navigate = useNavigate();
    
    useEffect(() => {

        loadRecords()

        return() => {
            setRecords([])
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status]) 

    const loadRecords = async () => {

        // let _addresses = []//unescapeNested( await get('address_book', {clientKey: UserData.clientKey}, [{fieldName: 'name', orderDirection: 'asc'}]) )

        if (status === 'Draft') {

            // let _bookings = await get('bookings_draft', {clientKey: UserData.clientKey, status: "Draft"}, [{fieldName: 'col_date', orderDirection: 'desc'}])
            let query = "SELECT bookings_draft.*, clients.name FROM bookings_draft LEFT JOIN clients ON bookings_draft.clientKey = clients.clientKey WHERE bookings_draft.clientKey = ? AND bookings_draft.status = ? ORDER BY bookings_draft.col_date DESC"
            let bindings = [UserData.clientKey, "Draft"]
            let _bookings = await getRecords(query, bindings)
            _bookings = unescapeNested(_bookings)
            setRecords(_bookings)
        }

        else {

            let _bookings = []
            if (status === "Live") {
                // _bookings = await get('bookings', {clientKey: UserData.clientKey, 'status <>': "Delivered"}, [{fieldName: 'col_date', orderDirection: 'desc'}])
                let query = "SELECT bookings.*, clients.name FROM bookings LEFT JOIN clients ON bookings.clientKey = clients.clientKey WHERE bookings.clientKey = ? AND bookings.status <> 'Delivered' ORDER BY bookings.col_date DESC"
                let bindings = [UserData.clientKey]
                _bookings = await getRecords(query, bindings)
            } else {
                // _bookings = await get('bookings', {clientKey: UserData.clientKey, status: "Delivered", 'del_date >=': dayjs(dates[0]).format('YYYY-MM-DD'), 'del_date <=': dayjs(dates[1]).format('YYYY-MM-DD')}, [{fieldName: 'col_date', orderDirection: 'desc'}])
                let query = "SELECT bookings.*, clients.name FROM bookings LEFT JOIN clients ON bookings.clientKey = clients.clientKey WHERE bookings.clientKey = ? AND bookings.status = 'Delivered' AND bookings.del_date >= ? AND bookings.del_date <= ? ORDER BY bookings.col_date DESC"
                let bindings = [UserData.clientKey, dayjs(dates[0]).format('YYYY-MM-DD'), dayjs(dates[1]).format('YYYY-MM-DD')]
                let data = await getRecords(query, bindings)
                console.log('data', data)
                _bookings = data
            }
            _bookings = unescapeNested(_bookings)
            setRecords(_bookings)
        }
        
        // setRecords( await fetchPurchases([dates[0].format('YYYY-MM-DD'), dates[1].format('YYYY-MM-DD')]) )   
    }

    useEffect( () => {

        loadRecords();

    }, [dates])

    
    const columns = [
        {
            title: "Order No.",
            render: data => <div>
                <div style={{fontWeight: 600}}>{data.orderNo || '-'}</div>
                <div style={{fontSize: '0.85em', color: '#888'}}>{data.crgoRef}</div>
            </div>,
            key: "ref",
        },
        {
            title: "Collection address",
            render: data => <div>{dayjs(data.col_date).format('DD/MM/YYYY')} - {data.col_time}<br/>{data.col_name}, {data.col_townName}, {data.col_postCode}</div>,
            key: "coladdress",
        },
        {
            title: "Delivery address",
            render: data => <div>{dayjs(data.del_date).format('DD/MM/YYYY')} - {data.del_time}<br/>{data.del_name}, {data.del_townName}, {data.del_postCode}</div>,
            key: "deladdress",
        },
        {
            title: "Vehicle",
            render: data => data.vanType,
            key: "vehicle",
        },
        {
            title: "Price",
            render: data => "£" + data.totalPrice,
            key: "price",
        },
        {
            title: "Status",
            render: data => {
                if (data.status === "Live") {
                    return <Tag color="blue">Live</Tag>;
                } else if (data.status === "Transit") {
                    return <Tag color="orange">In Transit</Tag>;
                } else if (data.status === "Delivered") {
                    return <Tag color="green">Delivered</Tag>;
                } else {
                    return data.status;
                }
            },
            key: "status",
        },
        
    ]

    const selectAddress = (record) => {

        if (status === "Draft") {
            navigate(`/bookings/draft/view/${record.bookingKey}`)
        } else {
            navigate(`/bookings/view/${record.bookingKey}`)
        }
        

    }

    const presetRanges = {
        'Last week': [
            dayjs(dayjs().startOf('week').add(-7, 'days').format('YYYY-MM-DD'), 'YYYY-MM-DD'), 
            dayjs(dayjs().endOf('week').add(-7, 'days').format('YYYY-MM-DD'), "YYYY-MM-DD")
        ],
        'Last month' : [
            dayjs(dayjs().startOf('month').add(-1, 'month').format('YYYY-MM-DD'), 'YYYY-MM-DD'), 
            dayjs(dayjs().endOf('month').add(-1, 'month').format('YYYY-MM-DD'), 'YYYY-MM-DD')
        ],
        'This week': [
            dayjs(dayjs().startOf('week').format('YYYY-MM-DD'), 'YYYY-MM-DD'), 
            dayjs(dayjs().endOf('week').format('YYYY-MM-DD'), "YYYY-MM-DD")
        ],
        'This month' : [
            dayjs(dayjs().startOf('month').format('YYYY-MM-DD'), 'YYYY-MM-DD'), 
            dayjs(dayjs().endOf('month').format('YYYY-MM-DD'), 'YYYY-MM-DD')
        ],
    }

    const exportCSVMultiline = async () => {

        try {
            console.log('Download started, records count:', records?.length);
            
            if (!records || records.length === 0) {
                console.warn('No records to export');
                return;
            }

            let csvExportData = `Opex Ref,OrderNo,Collection Date,Collection Name,Collection Town,Delivery Date,Delivery Name, Delivery Town,Qty,Kgs,Type,Vehicle,Price\r\n`;

            for (let i of records) {
                csvExportData += `${i.crgoRef},${i.orderNo},${dayjs(i.col_date).format('DD/MM/YYYY')},"${i.col_name?.replace(/,/g, "")}","${i.col_townName?.replace(/,/g, "")}",${dayjs(i.del_date).format('DD/MM/YYYY')},"${i.del_name?.replace(/,/g, "")}","${i.del_townName?.replace(/,/g, "")}",${i.itemCount},${i.itemKgs},${i.itemType},${i.vanType},${ ( parseFloat(parseFloat(i.totalPrice || 0)).toFixed(2)).toLocaleString() }\r\n`;
            }

            console.log('CSV data generated, length:', csvExportData.length);

            // Create blob with proper MIME type
            const file = new Blob([csvExportData], {type: 'text/csv;charset=utf-8;'});
            const url = URL.createObjectURL(file);
            console.log('Blob URL created:', url);

            // Create anchor element
            const element = document.createElement("a");
            element.href = url;
            element.download = `Delivered-Bookings.csv`;
            element.style.display = 'none'; // Hide the element
            
            // Append to body (required for Firefox)
            document.body.appendChild(element);
            console.log('Anchor element appended to body');

            // Trigger download
            element.click();
            console.log('Click event triggered');

            // Cleanup: remove element and revoke blob URL after a short delay
            setTimeout(() => {
                document.body.removeChild(element);
                URL.revokeObjectURL(url);
                console.log('Cleanup completed');
            }, 100);

        } catch (error) {
            console.error('Error exporting CSV:', error);
            // You could add user-facing error notification here
            alert('Failed to download CSV. Please check the browser console for details.');
        }
    }

    return (
        records ?
        <div style={{padding: 20}}>
            <div style={{display: 'flex', alignItems: "center"}}>
                <div style={{flex: 1}}>
                    <h2 style={{marginTop: 0, paddingLeft: 20}}>{status === "Draft" ? "Awaiting Acceptance" : `${status} Bookings`}</h2>
                </div>
                <div style={{marginRight: 20}}>
                    { status === "Delivered" &&
                    <div>
                    <DatePicker.RangePicker value={dates} format={"DD/MM/YYYY"} onChange={(dates) => setDates(dates)} ranges={presetRanges}/>
                    <Button style={{marginLeft: 10}} type="primary" onClick={exportCSVMultiline}>Download</Button>
                    </div>}
                </div>
                
            </div>

            <div style={{height: 'calc(100vh - 100px)', overflowY: 'scroll', overflowX: 'hidden'}}>
                { status === "Delivered" && <div style={{margin: 20}}>
                    <Row gutter={15}>
                        <Col xs={8}>
                            <div style={{backgroundColor: '#EFF2F5', padding: 30}}>
                                <h1>{records?.length}</h1>
                                <h4>Total Bookings</h4>
                            </div>
                        </Col>
                        <Col xs={8}>
                            <div style={{backgroundColor: '#EFF2F5', padding: 30}}>
                                <h1>£{records.reduce((sum, record) => sum + parseFloat(record.totalPrice || 0), 0).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</h1>
                                <h4>Total Bookings</h4>
                            </div>
                        </Col>
                    </Row>
                </div> }
            <AddressTable 
                columns={columns}
                records={records} 
                row_key="bookingKey"
                selectRow={selectAddress}
            /> 
            </div>
            
        </div>
        : <Loader />
        
    )
    
}

export default Bookings;
